export const apiDomain = 
    process.env.NODE_ENV === 'production' ? '//code.m-texte.de' : 'http://localhost:8080';